import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CoreParametersModel,
  SmartParametersModel,
  StrategicParametersModel,
  NewProductModal,
} from "../../interfaces/ProductObject";
import { resetAllState } from "./resetAllState";

// Define the initial state for the NewProduct model
const initialState: NewProductModal = {
  productId: null,
  coreParameters: {
    images: [],
    age: 0,
  },
  smartParameters: {
    productName: "",
    category: "",
    description: "",
  },
  strategicParameters: {
    askPrice: 0,
    sellingPoints: [],
  },
  metaData: {
    header: "List New Item",
    proceedButton: "Create",
  },
};

// Create a slice for NewProductDb
const newProductSlice = createSlice({
  name: "NewProductDb",
  initialState,
  reducers: {
    // Action to set core parameters
    setCoreParameters(state, action: PayloadAction<CoreParametersModel>) {
      state.coreParameters = action.payload;
    },
    // Action to set smart parameters
    setSmartParameters(state, action: PayloadAction<SmartParametersModel>) {
      state.smartParameters = action.payload;
    },
    // Action to set strategic parameters
    setStrategicParameters(
      state,
      action: PayloadAction<StrategicParametersModel>,
    ) {
      state.strategicParameters = action.payload;
    },
    setNewProduct(state, action: PayloadAction<NewProductModal>) {
      state.productId = action.payload.productId;
      state.coreParameters = action.payload.coreParameters;
      state.smartParameters = action.payload.smartParameters;
      state.strategicParameters = action.payload.strategicParameters;
      state.metaData = action.payload.metaData;
    },
    setNewProductToInitialState(state) {
      state.productId = initialState.productId;
      state.coreParameters = initialState.coreParameters;
      state.smartParameters = initialState.smartParameters;
      state.strategicParameters = initialState.strategicParameters;
      state.metaData = initialState.metaData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllState, () => initialState);
  },
});

// Export actions
export const {
  setCoreParameters,
  setSmartParameters,
  setStrategicParameters,
  setNewProduct,
  setNewProductToInitialState,
} = newProductSlice.actions;
export default newProductSlice.reducer;
